import React from 'react';
import DataTable from '../DataTable';
import { cn } from '../../../lib/utils';

const SampleTab = ({ samples, isFullScreen = false, embedded = false, compact = false }) => {
  if (!samples || samples.length === 0) {
    return (
      <div className={cn(
        'flex items-center justify-center text-gray-400 text-xs uppercase tracking-widest font-bold',
        embedded ? (compact ? 'py-6' : 'py-12') : 'h-full'
      )}>
        No sample data available
      </div>
    );
  }

  const columns = Object.keys(samples[0]).map(key => ({
    key,
    label: key
  }));

  return (
    <div className={embedded ? '' : 'h-full -m-4'}>
      <DataTable
        columns={columns}
        rows={samples}
        isFullScreen={isFullScreen}
        compact={compact}
      />
    </div>
  );
};

export default SampleTab;
